import { PageIcon } from "@src/packages/chime-ui";

export const Shield = () => (
  <PageIcon width="50%" src="/identity/icons/checkmark_shield.png" alt="Checkmark Shield Icon" />
);
